<template>
  <div class="admin-wrapper">
      <div class="columns">
        <div class="column is-12">
          <section class="hero is-info is-small">
            <div class="hero-body">
              <h1 class="title is-1">User Reports</h1>
              <h2 class="subtitle">Snapshot summary of key revenue metrics</h2>
            </div>
          </section><br><br>
          <!-- Video Creation Stats -->
          <section class="columns stats">
            <div class="column">
              <el-card class="box-card" v-loading="loading.newUsers">
                <p class="title">{{stats.newUsers.length}}</p>
                <p class="subtitle">New Users</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card" v-loading="loading.pausedUsers">
                <p class="title">{{stats.pausedUsers.length}}</p>
                <p class="subtitle">Pausing Soon</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card" v-loading="loading.canceledUsers">
                <p class="title">{{stats.canceledUsers.length}}</p>
                <p class="subtitle">Canceling Soon</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card" v-loading="loading.reactivations">
                <p class="title">{{stats.reactivatingUsers.length}}</p>
                <p class="subtitle">Reactivating Soon</p>
              </el-card>
            </div>
          </section><br>

          <!-- filter container -->
          <div class="filter-container">
            <el-select v-model="queryType" slot="prepend" @change="handleFilter">
              <el-option label="Canceling" value="canceling"></el-option>
              <el-option label="Pausing" value="pausing"></el-option>
              <el-option label="Reactivating" value="reactivating"></el-option>
            </el-select>
          </div><br>
          <!-- end filters -->

          <!-- Begin table -->
          <el-table :data="tableData" style="width:100%" align="center" v-loading="loading.canceledUsers">
            <!-- Resume Date -->
            <el-table-column label="Resume Date" width="180" v-if="this.queryType === 'reactivating'">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.paused.resumeDate | futureDate }}</span>
              </template>
            </el-table-column>
            <!-- Cancel Date -->
            <el-table-column label="Cancel Date" width="180" v-if="this.queryType === 'canceling'">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.canceled.endDate | futureDate }}</span>
              </template>
            </el-table-column>
            <!-- Pause Date -->
            <el-table-column label="Resume Date" width="180" v-if="this.queryType === 'pausing'">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.paused.startDate | futureDate }}</span>
              </template>
            </el-table-column>
            <!-- plan type -->
            <el-table-column prop="plan" label="Plan" width="160">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.plan" :type="scope.row.plan | planLevel">{{scope.row.plan}}</el-tag>
                <el-tag v-else type="info">N/A</el-tag>
              </template>
            </el-table-column>
            <!-- username -->
            <el-table-column label="Name" width="180">
              <template slot-scope="scope">
                <router-link :to="`/user/${scope.row._id}`">{{ scope.row.name }}</router-link>
              </template>
            </el-table-column>
            <!-- email -->
            <el-table-column label="Email" width="280">
              <template slot-scope="scope">
                {{ scope.row.email }}
              </template>
            </el-table-column>
            <!-- join date -->
            <el-table-column label="Date Joined" width="180">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.dateAdded | moment }}</span>
              </template>
            </el-table-column>
            <!-- actions -->
            <el-table-column label="Operations">
              <template slot-scope="scope">
                <el-button size="mini" @click="goToUser(scope.row._id)">View</el-button>
              </template>
            </el-table-column>
          </el-table>
          <br>
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import Reports from '@/api/report.service';
import '@/style/admin.scss';

export default {
  name: 'reports',
  data() {
    return {
      tableData: [],
      loading: {
        newUsers: true,
        pausedUsers: true,
        canceledUsers: true,
        reactivations: true
      },
      queryType: 'canceling',
      stats: {
        newUsers: [],
        pausedUsers: [],
        canceledUsers: [],
        reactivatingUsers: [],
      },
      metrics: {
        mrr: 0,
        arr: 0,
        ltv: 0,
        active_subscriptions: 0
      },
      me: this.$store.state.user
    }
  },
  filters: {
    subStatus(status) {
      const statusMap = {
        free: 'info',
        active: 'success',
        paused: 'warning',
        canceled: 'danger'
      }
      return statusMap[status];
    },
    planLevel(status) {
      const planMap = {
        free: 'info',
        alpha: 'success',
        alpha10: 'success',
        beta: 'success',
        beta18: 'success',
        gamma: 'success',
        gamma30: 'success',
        alpha365: 'success',
        beta365: 'success',
        gamma365: 'success',
        NA: 'info'
      }
      return planMap[status];
    },
    moment(date) {
      return moment(date).format('MM-DD-YYYY');
    },
    futureDate(date) {
      return moment(date).format('MMMM D, h:mm a');
    }
  },

  created() {
    this.getMetrics();
    this.getStats();
  },

  methods: {
    async getMetrics() {
      const { metrics } = await Reports.getMetrics();
      this.metrics = metrics[0];
    },

    async getStats() {
      this.stats.canceledUsers = await Reports.getCanceledUsers();
      this.tableData = this.stats.canceledUsers;
      this.loading.canceledUsers = false;

      this.stats.newUsers = await Reports.getNewUsers();
      this.loading.newUsers = false;

      this.stats.pausedUsers = await Reports.getPausedUsers();
      this.loading.pausedUsers = false;

      this.stats.reactivatingUsers = await Reports.getReactivations();
      this.loading.reactivations = false;
    },

    handleFilter() {
      const query = this.queryType;
      if (query === 'canceling') {
        this.tableData = this.stats.canceledUsers;
      } else if (query === 'pausing') {
        this.tableData = this.stats.pausedUsers;
      } else if (query === 'reactivating') {
        this.tableData = this.stats.reactivatingUsers;
      }
    },

    goToUser(id) {
      this.$router.push(`/user/${id}`);
    },

  }
}
</script>
